import React from 'react';
import { Link } from 'react-router-dom';
import { openAuth } from '../storefront/storefrontEvents';
import { STORE } from '../storefront/storeInfo';
import AccentText from '../storefront/AccentText';
import { copyLines } from '../storefront/homepageCopy';
import {
  IconArrowRight,
  IconArrowUpRight,
  IconHeadset,
  IconReceipt,
  IconSparkle,
  IconTag,
  Longhorn,
} from '../storefront/icons';

// Icons for benefits 1–4; their wording is editable (Admin → Homepage Text).
const BENEFIT_ICONS = [IconTag, IconHeadset, IconSparkle, IconReceipt];

const TradeActions = ({ tradeStatus, copy }) => {
  if (tradeStatus.state === 'active') {
    return (
      <div className="tp-trade__status">
        <p className="tp-trade__status-title" data-copy-key="trade.approvedTitle">{copy['trade.approvedTitle']}</p>
        <div className="tp-trade__actions">
          <Link to="/products" className="tp-btn tp-btn--light tp-btn--icon" data-copy-key="trade.approvedCta">
            {copy['trade.approvedCta']}
            <span className="tp-btn__icon"><IconArrowRight size={18} /></span>
          </Link>
          <Link to="/dashboard" className="tp-textlink tp-textlink--on-ink" data-copy-key="trade.approvedLink">
            {copy['trade.approvedLink']} <IconArrowRight size={16} />
          </Link>
        </div>
      </div>
    );
  }

  if (tradeStatus.state === 'pending') {
    return (
      <div className="tp-trade__status">
        <p className="tp-trade__status-title" data-copy-key="trade.pendingTitle">{copy['trade.pendingTitle']}</p>
        <p className="tp-trade__status-text" data-copy-key="trade.pendingText">{copy['trade.pendingText']}</p>
        <div className="tp-trade__actions">
          <Link to="/contact" className="tp-btn tp-btn--light" data-copy-key="trade.pendingCta">{copy['trade.pendingCta']}</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="tp-trade__actions">
      <button type="button" className="tp-btn tp-btn--light tp-btn--icon" onClick={() => openAuth('register')} data-copy-key="trade.applyCta">
        {copy['trade.applyCta']}
        <span className="tp-btn__icon"><IconArrowRight size={18} /></span>
      </button>
      <button type="button" className="tp-btn tp-btn--outline-light" onClick={() => openAuth('login')} data-copy-key="trade.signInCta">
        {copy['trade.signInCta']}
      </button>
      <Link to="/wholesale" className="tp-textlink tp-textlink--on-ink" data-copy-key="trade.learnMore">
        {copy['trade.learnMore']} <IconArrowRight size={16} />
      </Link>
    </div>
  );
};

const TradeProgram = ({ tradeStatus, copy }) => {
  const benefits = BENEFIT_ICONS.map((icon, i) => ({
    icon,
    title: copy[`trade.benefit${i + 1}Title`],
    text: copy[`trade.benefit${i + 1}Text`],
  }));
  const audiences = copyLines(copy['trade.audiences']);

  return (
    <section className="tp-section tp-trade" aria-labelledby="tp-trade-title">
      <Longhorn className="tp-trade__watermark" />
      <div className="tp-container tp-trade__grid">
        <div className="tp-trade__main" data-reveal>
          <span className="tp-eyebrow tp-eyebrow--on-ink" data-copy-key="trade.eyebrow">{copy['trade.eyebrow']}</span>
          <h2 id="tp-trade-title" className="tp-display tp-trade__title" data-copy-key="trade.title">
            <AccentText text={copy['trade.title']} />
          </h2>
          <p className="tp-trade__lede" data-copy-key="trade.body">{copy['trade.body']}</p>

          <ul className="tp-trade__benefits">
            {benefits.map(({ icon: Icon, title, text }, i) => (
              <li key={i} className="tp-benefit">
                <span className="tp-benefit__icon"><Icon size={18} /></span>
                <span>
                  <span className="tp-benefit__title" data-copy-key={`trade.benefit${i + 1}Title`}>{title}</span>
                  <span className="tp-benefit__text" data-copy-key={`trade.benefit${i + 1}Text`}>{text}</span>
                </span>
              </li>
            ))}
          </ul>

          <TradeActions tradeStatus={tradeStatus} copy={copy} />
        </div>

        <aside className="tp-trade__who" data-reveal style={{ '--reveal-delay': 120 }}>
          <p className="tp-trade__who-label" data-copy-key="trade.audienceLabel">{copy['trade.audienceLabel']}</p>
          <ol className="tp-trade__who-list" data-copy-key="trade.audiences">
            {audiences.map((audience, i) => (
              <li key={`${i}-${audience}`}>
                <span className="tp-trade__who-num">{String(i + 1).padStart(2, '0')}</span>
                {audience}
              </li>
            ))}
          </ol>
          <a className="tp-trade__faire" href={STORE.faireUrl} target="_blank" rel="noopener noreferrer">
            <span>
              <span className="tp-trade__faire-kicker" data-copy-key="trade.faireKicker">{copy['trade.faireKicker']}</span>
              <span data-copy-key="trade.faireLabel">{copy['trade.faireLabel']}</span>
            </span>
            <IconArrowUpRight size={18} />
          </a>
        </aside>
      </div>
    </section>
  );
};

export default TradeProgram;
